export default __webpack_public_path__ + "static/media/IoTEvents.82b3caef.svg";